<template>
    <img :src="image_url" alt="QR Code" />
</template>

<script>
export default {
    props: {
        qr_code_id: {
            type: String,
            required: true
        }
    },

    computed: {
        image_url() {
            if (this.qr_code_id == null) return null;

            return this.$rc.qrCodeURL(this.qr_code_id, 200, 200);
        },
    },
}
</script>

<style lang="scss" scoped>
img {
    max-width: 100%;
    height: auto;
    display: block;
}
</style>